import React from 'react'
import Nav from './nav';
import Banner from './banner';
// import Slider from './slider';
import Product from './product';
import Addvertise from './addvertise';
import Footer from './footer';
import Topbar from './top';
import SlickSlider from './slick_slider';
import Subscribe from './subscribe';
import Best_seller from './best_seller';
function main() {
  return (
    <div>
      <Nav />
      <Banner />
      <Topbar />
      {/* <SlickSlider /> */}
      <Product />
      <Addvertise />
      <Best_seller />
     <Subscribe />
      <Footer />
    </div>
  )
}

export default main
